import { useCallback, useEffect, useRef, useState } from 'react';
import { CLASS_NAME_HEADER } from '@/utils/constants/element/layout';
import ScrollListener from '../../events/ScrollListener';
const useScrollFixedDetect = () => {
    const headerHeightRef = useRef(0);
    const [isFixed, changeIsFixed] = useState(false);
    const ref = useRef();
    const updateFixedContent = useCallback(() => {
        if (!ref.current || !headerHeightRef.current) {
            return;
        }
        const headerHeight = headerHeightRef.current;
        const { y } = ref.current.getBoundingClientRect();
        changeIsFixed(y < headerHeight);
    }, [ref, headerHeightRef]);
    const onResizeWidth = useCallback(() => {
        headerHeightRef.current = document.querySelector(`.${CLASS_NAME_HEADER}`).clientHeight;
    }, [headerHeightRef]);
    useEffect(() => {
        onResizeWidth();
        updateFixedContent();
        const no = ScrollListener.setListener(() => {
            if (!ref) {
                return;
            }
            updateFixedContent();
        });
        return () => {
            ScrollListener.deleteListener(no);
        };
    }, [ref, updateFixedContent, headerHeightRef, onResizeWidth]);
    return {
        headerHeightRef,
        isFixed,
        ref,
    };
};
export const useScrollFixed = {
    useScrollFixedDetect,
};
export default useScrollFixed;
